var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("TIMESALESUI", {
    ref: "UI",
    attrs: {
      skin: _vm.skin,
      showLoading: _vm.showLoading,
      dataModel: _vm.dataModel,
      errorCode: _vm.error.code,
      settings: _vm.settings,
      labels: _vm.initedLabels,
      formatter: _vm.formatter
    },
    on: {
      "export-click": _vm.exportClick,
      "export-popover-hide": _vm.hideExportPopover,
      "settings-changed": _vm.changeSettings,
      "filter-change": _vm.changeFilter
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }